import React, { ReactElement, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { darkMode, lightMode } from '../../assets';

const NavigationBar: React.FC = (): ReactElement => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = window.localStorage.getItem('theme');
    return savedTheme || 'dark';
  });
  const [scrolled, setScrolled] = useState(false);

  function toggleTheme() {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    window.localStorage.setItem('theme', newTheme);
    document.documentElement.style.setProperty('color-scheme', newTheme);
    setTheme(newTheme);
  }

  useEffect(() => {
    const currentThemeValue = window.localStorage.getItem('theme');
    if (currentThemeValue) {
      document.documentElement.style.setProperty(
        'color-scheme',
        currentThemeValue,
      );
      setTheme(currentThemeValue);
    }
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
      <div className="nav_inner">
        <NavLink className="nav_logo link" to="/">
          <span className="nav_logo_name">Olúwáségun</span>
          <span className="nav_logo_dot" aria-hidden="true" />
        </NavLink>

        <div className="nav_links">
          <NavLink
            className={({ isActive }) =>
              `nav_link${isActive ? ' nav_link--active' : ''}`
            }
            to="/about"
          >
            About
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `nav_link${isActive ? ' nav_link--active' : ''}`
            }
            to="/work"
          >
            Explorations
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              `nav_cta${isActive ? ' nav_cta--active' : ''}`
            }
            to="/contact"
          >
            Contact
          </NavLink>
          <button
            type="button"
            className="nav_theme_btn"
            onClick={toggleTheme}
            aria-label={
              theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'
            }
          >
            <img
              src={theme === 'light' ? darkMode : lightMode}
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
